function progressBar() {
  document.addEventListener("DOMContentLoaded", function() {
    const progressbarinner = document.querySelector('.progress-bar__inner');

    // Check if the progress bar exists on the page
    if (!progressbarinner) {
      return; // Exit the function if there's no progress bar
    }
    
    const heroSection = document.querySelector('.js-hero-article-longform');

    // Get the height of the hero section
    const heroHeight = heroSection ? heroSection.offsetHeight : 0;

    // Setup a timer
    var timeout;
    
    // Listen for scroll events
    window.addEventListener('scroll', function ( event ) {
      // console.log('no debounce');

      // If there's a timer, cancel it
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }

      // Setup the new requestAnimationFrame()
      timeout = window.requestAnimationFrame(function () {
        // console.log('debounced')
        // Run our scroll functions
        let h = document.documentElement;
        let scrollTop = h.scrollTop || document.body.scrollTop;
        let scrollHeight = h.scrollHeight || document.body.scrollHeight;

        /// Calculate the scrollable height after the hero section
        let scrollableHeight = scrollHeight - h.clientHeight - heroHeight;

        // Adjust scroll position to start after the hero section
        let scrolled = Math.max(0, scrollTop - heroHeight); // Ensure scrolled isn't negative

        // Calculate the percentage scrolled
        let percent = (scrolled / scrollableHeight) * 100;

        progressbarinner.style.width = percent + '%';

      });

    }, false);
  })
};

export default function() {
  progressBar();
}

